import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/InventoryAllocations'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class InventoryAllocationsStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "InventoryAllocationsStore",
			variables: true,
		})
	}
}

export async function load_InventoryAllocations(params) {
  await initClient()

	const store = new InventoryAllocationsStore()

	await store.fetch(params)

	return {
		InventoryAllocations: store,
	}
}
